module.exports = __webpack_public_path__ + "img/invoice.30295e4e.png";